import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICreateTransportadora, IUpdateTransportadora } from './transportadora.model';

@Injectable({
  providedIn: 'root'
})
export class TransportadoraService {
  constructor(private http: HttpClient) {}

  public GetTransportadoras(): Observable<any> {
    const url = `${environment.baseURL}Transportadora/GetTransportadoras`;
    return this.http.get<any>(url);
  }

  public GetTransportadoraById(id: number): Observable<any> {
    const url = `${environment.baseURL}Transportadora/GetTransportadoraById?id=${id}`;
    return this.http.get<any>(url);
  }

  public CreateTransportadora(body: ICreateTransportadora): Observable<any> {
    const url = `${environment.baseURL}Transportadora/CreateTransportadora`;
    return this.http.post<any>(url, body);
  }

  public UpdateTransportadora(body: IUpdateTransportadora): Observable<any> {
    const url = `${environment.baseURL}Transportadora/UpdateTransportadora?id=${body.PK_TPTD}`;
    return this.http.put<any>(url, body);
  }

  public DeleteTransportadora(id: number): Observable<any> {
    const url = `${environment.baseURL}Transportadora/DeleteTransportadora?id=${id}`;
    return this.http.delete<any>(url);
  }
}
